<template>
  <div>
    <Dialog
      :visible.sync="quotationGradesForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Quotation Grade Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="quoteGradeName">Name</label>
          <InputText
            id="quoteGradeName"
            v-model.trim="quotationGrade.quoteGradeName"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !quotationGrade.quoteGradeName
            }"
            :disabled="disabledArr.includes('quotationGradeName')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !quotationGrade.quoteGradeName"
            >Name is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="quoteGradeCode">Code</label>
          <InputText
            id="quoteGradeCode"
            v-model.trim="quotationGrade.quoteGradeCode"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !quotationGrade.quoteGradeCode
            }"
            :disabled="disabledArr.includes('quoteGradeCode')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !quotationGrade.quoteGradeCode"
            >Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="active">Mark Active</label>
          <SelectButton
            v-model="quotationGrade.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    "quotationGradeToEdit",
    "quotationGradesForm",
    "sendingRequest",
    "disabledArr"
  ],
  data: () => ({
    quotationGrade: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.quotationGradeToEdit && this.quotationGradeToEdit.id) {
      this.quotationGrade = { ...this.quotationGradeToEdit };
      this.quotationGradeToEdit.active
        ? (this.quotationGrade.active = { name: "Active", value: true })
        : (this.quotationGrade.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    quotationGradesForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.quotationGradesForm;
      }
    }
  },
  methods: {
    reset() {
      this.quotationGrade = {};
    },
    save() {
      this.submitted = true;

      let obj = { ...this.quotationGrade };

      if (obj.quoteGradeName) {
        if (obj.active instanceof Object) {
          obj.active = obj.active.value;
        }

        this.$emit("save", obj);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
